import React from 'react'
import { Button } from 'src/components/atoms'

/**
 * org 単位の IP アクセス制限（boba-server #3479）により、許可されていない
 * ネットワークからのアクセスだと判定されたときの案内。
 *
 * サーバーは所属する組織がすべて制限対象で除外された場合に
 * `network_restricted` を返すため、組織が未紐づけのケース（NoAuthorizations）と
 * 区別して、ネットワークが理由であることだけを案内できる。
 */
const NetworkRestricted: React.FC = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2>お使いのネットワークからは利用できません</h2>
      <p>
        ご利用中の組織は、接続元のネットワークが限定されています。
        <br />
        許可されたネットワークに接続したうえで、ページを再読み込みしてください。
        <br />
        許可されたネットワークが分からない場合、お手数ですが、ログイン中のメールアドレスを添えて、管理者までご連絡ください。
      </p>
      <Button
        color="primary"
        size="large"
        title="ページを再読み込み"
        onClick={() => window.location.reload()}
      />
    </div>
  )
}

export default NetworkRestricted
